import { ElementType } from 'react';
import classnames from 'classnames';

import { translation, TranslatedComponent } from '@hh.ru/front-static-app';
import { SPALink } from '@hh.ru/redux-spa-middleware';
import { formatNewLine } from 'bloko/common/trl';

import { useIsRabotaBy } from 'src/hooks/useSite';
import { useSelector } from 'src/modules/useSelector';
import sendAnalytics from 'src/utils/analytics';

import styles from 'src/components/Logo/logo.less';

const TrlKeys = {
    title: 'statportal.logo.title',
};

interface LogoProps {
    isFull?: boolean;
}

const Logo: TranslatedComponent<LogoProps> = ({ isFull, trls }) => {
    const staticHost = useSelector(({ config }) => config.staticHost);
    const pageName = useSelector(({ request }) => request.pageName);

    const host = useSelector((state) => state.request.host);
    const isRabotaBy = useIsRabotaBy();

    const src = isRabotaBy ? 'logo.rabota.by.min.svg' : 'logo.svg';

    const isIndexPage = pageName === 'Index';

    const Element: ElementType = isIndexPage ? 'span' : SPALink;
    const linkProps = isIndexPage
        ? {}
        : {
              to: '/employer/statistics/index',
              onClick: sendAnalytics.logoClick,
          };

    return (
        <Element
            className={classnames(styles.logo, {
                [styles.logoFull]: isFull,
            })}
            {...linkProps}
        >
            {staticHost && (
                <img className={styles.logoImage} src={`${staticHost}/static/files/images/${src}`} alt={host} />
            )}
            <span className={styles.logoName}>{formatNewLine(trls[TrlKeys.title])}</span>
        </Element>
    );
};

export default translation(Logo);
